import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { END_LOADING, ERROR, START_LOADING } from '@/main/store/listEditTypes';
import { NdSklad } from '@/modules/sklad/ndSklad';
import { editActions, editMutations } from '@/modules/sklad/ndPrijemka/polozky/store/types';

import { apiProvider } from '../api';
import { NAME as name, CRUMB_LABEL_KEY, ND_SKLAD } from '../constants';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		PretacPzn: [],
		SkladMjId: [],
	},
	edit: {
		BalicJdn: null as number | null,
		EshopNr: null as string | null,
		ExtRowNr: null as number | null,
		MioId: null as number | null,
		Mnozstvi: null as number | null,
		Mnozstvi2: null as number | null,
		Nc: null as number | null,
		NcCelk: null as number | null,
		NcKor: null as number | null,
		NdNr: null as string | null,
		Pc: null as number | null,
		PcNdsklad: null as number | null,
		PretacPzn: null as number | null,
		PrijemkaId: null as number | null,
		SkladMjId: null as number | null,
		Skladmisto: null as string | null,
		SkladmistoId: null as number | null,
		SkladmistoIdText: null as string | null,
		Text: null as string | null,
		UzavreniDat: null as Date | null,
		VyrobekndOzn: null as string | null,
		ZakazkaId: null as number | null,
		ZaznamId: null as number | null,
		eanKlic: null as string | null,
		SkladOzn: null as number | null,
		NcCelkKor: null as number | null,
		NdprijemPzn: null as number | null,
		NcCelkPrp: null as boolean | null,
		LeftToDeliverCount: null as number | null,
		PrordersId: null as number | null,
		Discount: null as number | null,
		DiscAfterCalc: null as number | null,
		PriceAfterDisc: null as number | null,
		Gst: null as number | null,
		PriceAfterDiscWithGst: null as number | null,
		Vat: null as number | null,
		PriceAfterDiscWithVat: null as number | null,
	},
	localState: {
		ndNrDisable: false as boolean,
		textDisabled: false as boolean,
		ncUnavailable: false as boolean,
		skladKartaPnc: null as number | null,
	},
	depTableNames: [],
	depTableSettings: {},
	extraActions: {
		async [ND_SKLAD]({ commit, dispatch }, NdSkladId) {
			try {
				commit(START_LOADING);
				let resp = { data: {} };
				if (NdSkladId) { resp = await NdSklad.apiProvider.entity(NdSkladId); }
				commit(ND_SKLAD, { data: resp.data });
				return resp;
			} catch (err) {
				dispatch(ERROR, { err }, { root: true });
				return err;
			} finally {
				commit(END_LOADING);
			}
		},
		async [editActions.ND_SKLAD_POLOZKY_MAPPER]({ commit, dispatch }, { data }) {
			const dataForMutation = {
				NdNr: data.ndnr,
				ndNrDisable: !!data.ndnr,
				Text: data.text,
				textDisabled: !!data.ndnr,
				BalicJdn: data.vydejmjid,
				ncUnavailable: false as boolean,
				VyrobekndOzn: null as string | null,
			};
			const { data: skladData } = await dispatch(ND_SKLAD, data.value);
			dataForMutation.ncUnavailable = !skladData.Nc;
			dataForMutation.VyrobekndOzn = skladData.VyrobekndOzn;
			commit(editMutations.ND_SKLAD_POLOZKY_MAPPER, { data: dataForMutation });
		},
	},
	extraGetters: {},
	extraMutations: {
		[ND_SKLAD](state, { data }) {
			state.edit.Skladmisto = data.SkladmistoIdSkladmisto || null;
			state.edit.SkladmistoId = data.SkladmistoId || null;
			state.edit.SkladmistoIdText = data.SkladmistoIdPopis || null;
			state.edit.Nc = data.Nc || null;
			state.edit.NcCelk = data.Pnc || null;
			state.edit.Pc = data.Pc || null;
			state.edit.BalicJdn = data.BalicJdn || null;
			state.edit.SkladMjId = data.SkladMjId || null;
			state.localState.skladKartaPnc = data.Pnc || null;
		},
		[editMutations.ND_SKLAD_POLOZKY_MAPPER](state, { data }) {
			state.edit.NdNr = data.NdNr;
			state.localState.ndNrDisable = data.ndNrDisable;
			state.edit.Text = data.Text;
			state.localState.textDisabled = data.textDisabled;
			state.edit.BalicJdn = data.BalicJdn;
			state.localState.ncUnavailable = data.ncUnavailable;
			state.edit.VyrobekndOzn = data.VyrobekndOzn;
		},
	},
	props: {
		mode: null,
		ncCelkPrpActual: null as boolean | null,
		SkladOzn: null as number | null,
		MioId: null as number | null,
		MioNdNr: null as string | null,
		Quantity: null as number | null,
		TotalMnozstvi: null as number | null,
		VyrobekndOzn: null as string | null,
	},
});
